import { CnAsyncSelect, componentMap as formComponentMap, } from '@cainiaofe/cn-ui';
import { DisplayPosition } from '@/common/manager/position//display-position';
import { calculateRequestExecute, handleSelectDataSource, handleSelectRequestConfig, } from '@/common/util/util';
import isPlainObject from 'lodash/isPlainObject';
import { __dataSource__, __filterValue__, __formValue__, } from '@/common/util/expr-const';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'AutoComplete',
    component: CnAsyncSelect.AutoComplete,
    formComponent: formComponentMap.CnSelectAutoComplete,
    formItemBeforeHandler: (formItem, config) => {
        const { isDesign, urlParams, formValue, state } = config;
        handleSelectRequestConfig({
            componentProps: formItem?.['x-component-props'],
            isDesign,
            urlParamsDataSource: urlParams,
            recordDataSource: formValue,
            state,
        });
        handleSelectDataSource({
            componentProps: formItem?.['x-component-props'],
            state,
        });
        const componentProps = formItem?.['x-component-props'];
        if (isPlainObject(componentProps)) {
            componentProps.onFocus = (e, run) => {
                const execute = calculateRequestExecute(componentProps?.requestConfig, {
                    [__formValue__]: formValue,
                    [__filterValue__]: formValue,
                    [__dataSource__]: state,
                }, formValue || {}, state);
                if (execute !== false) {
                    run?.();
                }
            };
            componentProps.onVisibleChange = undefined;
        }
    },
    filterItemBeforeHandler: (filterItemProps, config) => {
        handleSelectRequestConfig(config);
        handleSelectDataSource(config);
    },
};
